module.exports = __webpack_public_path__ + "static/media/misme_halonen-quote.cc07ad85.jpeg";